// src/pages/Login/Login.jsx
//
// The logged-out landing page (route: /login). Rendered only when there is
// no authenticated user -- App.js's /login route guards the authenticated
// case itself (redirects away via getPostAuthRoute before this component
// ever mounts). Content here is identical regardless of how the user got
// here (direct visit vs. a blocked-route redirect carrying `redirect_url`):
// this component never reads location.search -- the redirect_url handling
// happens entirely in App.js's initUser, after `onLogin` (initUser) fires.
import { GoogleOAuthProvider } from '@react-oauth/google';
import GoogleAuth from '../../components/Auth/Google/GoogleAuth';
import Config from '../../utils/Config';
import styles from './Login.module.css';

const Login = ({ initUser }) => {
  return (
    <div className={styles.pageShell}>
      <div className={styles.contentInner}>
        <h1 className={styles.heading}>Log in to continue</h1>
        <p className={styles.context}>
          Sign in with your Google account to access CliqMetrics.
        </p>
        <div className={styles.ctaRow}>
          {Config.GOOGLE_AUTH_ID ? (
            <GoogleOAuthProvider clientId={Config.GOOGLE_AUTH_ID}>
              <GoogleAuth onLogin={initUser} variant="branded" />
            </GoogleOAuthProvider>
          ) : (
            <button disabled className={styles.button}>Login with Google</button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Login;
